import React from "react";

export const HelpCircleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5659_79686)">
      <path
        d="M6.0587 6.00004C6.21543 5.55449 6.5248 5.17878 6.932 4.93946C7.3392 4.70015 7.81796 4.61267 8.28348 4.69252C8.749 4.77236 9.17124 5.01439 9.47542 5.37573C9.77959 5.73706 9.94607 6.19439 9.94536 6.66671C9.94536 8.00004 7.94536 8.66671 7.94536 8.66671M7.9987 11.3334H8.00536M14.6654 8.00004C14.6654 11.6819 11.6806 14.6667 7.9987 14.6667C4.3168 14.6667 1.33203 11.6819 1.33203 8.00004C1.33203 4.31814 4.3168 1.33337 7.9987 1.33337C11.6806 1.33337 14.6654 4.31814 14.6654 8.00004Z"
        stroke="#98A2B3"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5659_79686">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
